import React from 'react';
import { Image } from 'semantic-ui-react';
import classNames from 'classnames';
import styles from './styles.module.scss';

export const CircularImage = ({ src, alt, id, objectFit, onError, className }) => (
  <Image
    centered
    circular
    className={classNames(styles.circularImage, className && className)}
    id={id}
    src={src}
    alt={alt}
    onError={onError}
    style={{ objectFit }}
  />
);
